module.exports = __webpack_public_path__ + "img/zphd_bj_s2.87298dab.png";